import { useMutation, useQueryClient } from '@tanstack/react-query'
import { JsonRpcError } from '~/types'
import { WithdrawRequest, WithdrawRequestListResponse } from '../types'
import { keepStaffContext } from './keepStaffContext'

export const useWithdrawApprove = () => {
    const queryClient = useQueryClient()

    return useMutation<WithdrawRequest, JsonRpcError, unknown>({
        // `override_reason` pays a row the checks disqualified. Sent as given
        // and validated on the server, which refuses a blocked row without one
        // -- this hook must not be the thing deciding a reason was good enough.
        mutationFn: async ({ uuid, comment, override_reason }) => {
            const resp = await fetch('/rpc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'bank.withdraw_request.approve',
                    params: {
                        uuid,
                        comment,
                        override_reason,
                    },
                }),
            })
            const data = await resp.json()

            if (data.error) {
                throw data
            } else {
                return data.result
            }
        },
        onSuccess: (data) => {
            queryClient.setQueriesData(['withdraw_requests'], (prev: WithdrawRequestListResponse) => {
                return {
                    ...prev,
                    data: prev.data?.map((item) => {
                        if (item.uuid === data.uuid) {
                            return keepStaffContext(item, data)
                        } else {
                            return item
                        }
                    }),
                }
            })
            queryClient.invalidateQueries(['withdraw_request.summary'])
            // The verdict and block pills are cached for good (`staleTime:
            // Infinity`); an action is exactly when they may have moved.
            queryClient.invalidateQueries(['withdraw_verdicts'])
            queryClient.invalidateQueries(['payout_wallet_balance'])
        },
        retry: false,
    })
}
